import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@quikr/ui';

export default function CitySuggest (props) {
  const { name, items, selectedVal, changeCB, error, commonRequest, citySuggestRequest } = props;
  const { loading: loadingCommon, data: dataCommon } = commonRequest();
  const [cities, setCities] = useState(items);
  const [loadCities, { data: dataCtySgst, called: calledCtySgst, loading: loadingCtySgst }] =
    citySuggestRequest();

  const handleAutoComplete = input => {
    if (input) {
      fetchCities(input);
    }
  };

  const fetchCities = input => {
    try {
      loadCities({
        variables: {
          payload: {
            query: input
          }
        }
      });
    } catch (e) {
      // Need to handle
    }
  };

  const handleChange = cityId => {
    if (cityId) {
      const city = cities.find(_city => _city.id === cityId);
      changeCB && changeCB(city);
    } else {
      changeCB && changeCB('');
    }
  };

  useEffect(() => {
    if (calledCtySgst && !loadingCtySgst) {
      if (dataCtySgst) {
        setCities(dataCtySgst.citysuggest);
      } else {
        setCities(items);
      }
    }
  }, [calledCtySgst, loadingCtySgst, dataCtySgst]);

  if (loadingCommon) return null;
  const { isMobile } = dataCommon;

  return (
    <Select
      isMobile={isMobile}
      items={cities}
      onAutoComplete={handleAutoComplete}
      onChange={handleChange}
      labelText="City*"
      valueKey="id"
      labelKey="name"
      name={name}
      selectedVal={selectedVal}
      throttle={300}
      error={error}
    ></Select>
  );
}

CitySuggest.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.array,
  selectedVal: PropTypes.string,
  changeCB: PropTypes.func,
  error: PropTypes.string,
  commonRequest: PropTypes.func,
  citySuggestRequest: PropTypes.func
};

CitySuggest.defaultProps = {
  items: [],
  changeCB: null
};
